import axios from 'api';

// /api/super/reference/languages/
// Backend filterset: { scope: ["exact"], stt_provider: ["exact"] }. Search: code, name.

export const getLanguageData = (filtersData, signal) => {
  const { page_size, page, search, scope, stt_provider } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (scope) params.set('scope', scope);
  if (stt_provider) params.set('stt_provider', stt_provider);
  return axios.get(`/api/super/reference/languages/?${params.toString()}`, { signal });
};

export const createLanguage = (params) => {
  return axios.post(`/api/super/reference/languages/`, params);
};

export const updateLanguage = (params) => {
  return axios.patch(`/api/super/reference/languages/${params.id}/`, params);
};

export const deleteLanguage = (id) => {
  return axios.delete(`/api/super/reference/languages/${id}/`);
};

export const getAllPublicLanguages = () => {
  return axios.get(`/api/super/reference/languages/?page_size=1000`);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const getCustomerLanguageData = removedStub('getCustomerLanguageData');
export const createCustomerLanguage = removedStub('createCustomerLanguage');
export const updateCustomerLanguage = removedStub('updateCustomerLanguage');
export const deleteCustomerLanguage = removedStub('deleteCustomerLanguage');
